/* canvora-pages-clone.js — behaviour for the Kooly-parity content pages (Cowork content-pages builder, 2026-10-26):
   FAQ search, carousels (arrows + dots), journal "View all", "Add the whole wall", recently viewed. No dependencies. */
(function () {
  'use strict';
  if (window.__kpPages) return; window.__kpPages = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { var d = c / 100; return '$' + (d % 1 === 0 ? d.toLocaleString('en-US') : d.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })); }

  /* FAQ search: filters questions (and their answers) by every typed word; empty categories hide; matches open */
  function faq(box) {
    var q = box.querySelector('[data-kp-faq-q]'); if (!q) return;
    var none = box.querySelector('[data-kp-faq-none]');
    q.addEventListener('input', function () {
      var words = q.value.toLowerCase().split(/\s+/).filter(Boolean), shown = 0;
      $$('[data-kp-faq-group]', box).forEach(function (g) {
        var any = 0;
        $$('[data-kp-faq-item]', g).forEach(function (d) {
          var ok = words.every(function (w) { return d.textContent.toLowerCase().indexOf(w) >= 0; });
          d.hidden = !ok; if (ok) { any++; d.open = words.length > 0 && q.value.length >= 3; }
        });
        g.hidden = !any; shown += any;
      });
      if (none) none.hidden = shown > 0;
    });
  }

  /* carousels: [data-kp-scroll] rows with [data-kp-prev]/[data-kp-next] and optional dots in the same block */
  function carousel(row) {
    var box = row.closest('[data-kp-carousel]') || row.parentElement;
    var prev = box.querySelector('[data-kp-prev]'), next = box.querySelector('[data-kp-next]'), dots = box.querySelector('[data-kp-dotset]');
    function pages() { return Math.max(1, Math.ceil((row.scrollWidth - 4) / Math.max(1, row.clientWidth))); }
    function page() { return row.scrollLeft + row.clientWidth >= row.scrollWidth - 2 ? pages() - 1 : Math.round(row.scrollLeft / Math.max(1, row.clientWidth)); }
    function sync() {
      var n = pages(), p = page();
      if (prev) prev.disabled = row.scrollLeft <= 2;
      if (next) next.disabled = row.scrollLeft + row.clientWidth >= row.scrollWidth - 2;
      var arrows = box.querySelector('[data-kp-arrows]'); if (arrows) arrows.hidden = n <= 1;
      if (dots) {
        if (dots.children.length !== n) { dots.innerHTML = ''; for (var i = 0; i < n; i++) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Page ' + (i + 1)); (function (k) { b.addEventListener('click', function () { row.scrollTo({ left: k * row.clientWidth, behavior: 'smooth' }); }); })(i); dots.appendChild(b); } }
        $$('button', dots).forEach(function (b, i) { b.classList.toggle('is-on', i === p); });
        var d = box.querySelector('[data-kp-dots]'); if (d) d.hidden = n <= 1;
      }
    }
    if (prev) prev.addEventListener('click', function () { row.scrollBy({ left: -row.clientWidth, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { row.scrollBy({ left: row.clientWidth, behavior: 'smooth' }); });
    var t; row.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    window.addEventListener('resize', sync); sync();
  }

  /* journal "View all": every post as a grid (the links are in the HTML either way) */
  document.addEventListener('click', function (e) {
    var v = e.target.closest && e.target.closest('[data-kp-viewall]');
    if (v) { var b = v.closest('.kp-posts'); if (b) b.classList.add('is-all'); }
  });

  /* "Add the whole wall": every piece of the wall in one add, then the cart drawer (or the cart page) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kp-set-add]'); if (!btn) return;
    var box = btn.closest('[data-kp-set]'), err = box.querySelector('[data-kp-set-err]');
    var ids = (box.dataset.ids || '').split(',').filter(Boolean); if (!ids.length) return;
    var drawer = document.querySelector('cart-drawer'), label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…'; if (err) err.hidden = true;
    var body = { items: ids.map(function (id) { return { id: +id, quantity: 1 }; }) };
    if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'add'); return j; }); })
      .then(function (j) { btn.disabled = false; btn.textContent = label; if (drawer && j.sections && typeof drawer.renderContents === 'function') drawer.renderContents(j); else window.location.href = root + 'cart'; })
      .catch(function (x) { btn.disabled = false; btn.textContent = label; if (err) { err.textContent = 'Could not add the wall: ' + (x.message || 'please try again') + '. You can add each piece from its own page.'; err.hidden = false; } });
  });

  /* recently viewed (written on product pages by snippets/canvora-k-recent mode 'record'; this browser only) */
  function recent(box) {
    var a = []; try { a = JSON.parse(localStorage.getItem('cvk_recent_v1') || '[]'); } catch (e) {}
    if (!Array.isArray(a)) a = [];
    var skip = (box.dataset.exclude || '').split(','); a = a.filter(function (x) { return x && x.u && skip.indexOf(x.h) < 0; }).slice(0, 4);
    if (!a.length) return;
    var row = box.querySelector('[data-kp-recent-row]');
    row.innerHTML = a.map(function (x) { return '<a href="' + esc(x.u) + '"><img src="' + esc(x.i) + '" alt="" loading="lazy" width="600" height="600"><span class="t">' + esc(x.t) + '</span>' + (typeof x.p === 'string' && x.p ? '<span class="p">' + esc(x.p) + '</span>' : '') /* r8: text from canvora-card-price; old numeric entries were the poster price, so they show none */ + '</a>'; }).join('');
    row.hidden = false; box.classList.add('kp-recent--has');
  }

  function init() {
    $$('[data-kp-faq]').forEach(faq);
    $$('[data-kp-scroll]').forEach(carousel);
    $$('[data-kp-recent]').forEach(recent);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
